module.exports = __webpack_public_path__ + "static/media/backward-w-icon.6ebff516.svg";